module.exports = __webpack_public_path__ + "src/assets/games/9/23.jpg";